import BallPulse from '@tock/shared/components/BallPulse';
import baseLoadable, {
  DefaultComponent,
  LoadableComponent,
  OptionsWithoutResolver,
} from '@loadable/component';

export function loadable<Props>(
  loadFn: (props: Props) => Promise<DefaultComponent<Props>>,
  options?: OptionsWithoutResolver<Props>
): LoadableComponent<Props> {
  const Component = baseLoadable(loadFn, {
    fallback: (
      <div className="AsyncComponent-loading">
        <BallPulse position="INLINE" data-testid="loading-ballpulse" />
      </div>
    ),
    ...options,
  });

  return Component;
}
